/* Product page behavior: gallery sync, variant switching via Section Rendering, sticky add to cart, recommendations. */
if (!customElements.get('hw-product')) {
  class HwProduct extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.url = this.dataset.url;
      this.addEventListener('change', (e) => { if (e.target.matches('[data-option]')) this.onVariant(); });
      this.setupGallery();
      this.setupSticky();
      this.loadRecs();
    }
    selected() {
      return [...this.querySelectorAll('[data-option]:checked')].sort((a, b) => a.dataset.option - b.dataset.option).map((i) => i.value);
    }
    async onVariant() {
      const form = this.querySelector('form.pform');
      const optionValues = this.selected();
      // The server resolves option values to a variant: request the page section with the options as selected.
      const params = new URLSearchParams({ section_id: this.section });
      optionValues.forEach((v, i) => params.set(`option_values[${i}]`, v));
      // Find the variant id from the product JSON endpoint.
      const product = await (await fetch(`${this.url}.js`)).json();
      const v = product.variants.find((x) => x.options.every((o, i) => o === optionValues[i]));
      const atc = this.querySelector('[data-atc]');
      const priceWrap = this.querySelector('[data-price-wrap]') || this.querySelector('[data-price]')?.parentElement;
      if (!v) { atc.disabled = true; atc.textContent = 'Unavailable'; this.sync(false, null); return; }
      form.querySelector('[data-variant-id]').value = v.id;
      const res = await fetch(`${this.url}?variant=${v.id}&section_id=${this.section}`);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const newPrice = doc.querySelector('[data-price]');
      if (newPrice && priceWrap) this.querySelector('[data-price]').replaceWith(newPrice);
      atc.disabled = !v.available;
      atc.textContent = v.available ? 'Add to cart' : 'Sold out';
      this.sync(v.available, newPrice?.querySelector('.price__now')?.textContent, v.featured_image?.id ?? v.featured_media?.id);
      if (!this.closest('#QuickView')) history.replaceState(null, '', `${this.url}?variant=${v.id}`);
    }
    sync(available, price, mediaId) {
      const sb = this.querySelector('[data-atc-sticky]');
      if (sb) { sb.disabled = !available; sb.textContent = available ? 'Add to cart' : 'Sold out'; }
      const sp = this.querySelector('[data-sticky-price]');
      if (sp && price) sp.textContent = price;
      if (mediaId) {
        const slide = this.querySelector(`[data-media-id="${mediaId}"]`);
        const track = this.querySelector('[data-gallery] [data-track]');
        if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
    }
    setupGallery() {
      const track = this.querySelector('[data-gallery] [data-track]');
      if (!track) return;
      const slides = [...track.children];
      const dots = this.querySelector('[data-dots]');
      const thumbs = [...this.querySelectorAll('[data-thumb]')];
      const mark = (i) => {
        [...(dots?.children || [])].forEach((d, n) => d.setAttribute('aria-current', n === i));
        thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i));
      };
      if (dots) slides.forEach((_, n) => { const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', `Image ${n + 1}`); b.onclick = () => track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' }); dots.append(b); });
      thumbs.forEach((t, n) => t.onclick = () => track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' }));
      let to;
      track.addEventListener('scroll', () => { clearTimeout(to); to = setTimeout(() => mark(Math.round(track.scrollLeft / track.clientWidth)), 60); }, { passive: true });
      mark(0);
    }
    setupSticky() {
      const bar = this.querySelector('[data-sticky-atc]');
      const anchor = this.querySelector('[data-atc]');
      if (!bar || !anchor || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(([e]) => { bar.hidden = e.isIntersecting || e.boundingClientRect.top > 0; }, { threshold: 0 }).observe(anchor);
    }
    async loadRecs() {
      const holder = document.querySelector('[data-recs-url]');
      if (!holder || this.closest('#QuickView')) return;
      const io = new IntersectionObserver(async ([e]) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        try {
          const html = await (await fetch(holder.dataset.recsUrl)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const sec = doc.querySelector('.shopify-section');
          if (sec) holder.closest('.shopify-section').innerHTML = sec.innerHTML;
        } catch {}
      }, { rootMargin: '600px' });
      io.observe(holder.parentElement);
    }
  }
  customElements.define('hw-product', HwProduct);
}
